"use client";
import { useRef, useEffect, useState } from "react";

export default function TrustBox({
  ctx,
  bgWrapper = "bg-white",
}: {
  ctx: string;
  bgWrapper?: string;
}) {
  const ref = useRef(null);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
    const interval = setInterval(() => {
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(ref.current, true);
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return (
    <>
      {isClient && (
        <div className="carousel">
          <div
            suppressHydrationWarning
            ref={ref}
            className={`trustpilot-widget ${
              ctx === "quote" ? `${bgWrapper}` : "bg-beige"
            } rounded-1/2 min-[620px]:p-1.5 py-1.5 mt-1 dt:mt-2 mb-5 dt:mb-0 max-[360px]:w-[320px]`}
            data-locale="en-US"
            data-template-id="53aa8912dec7e10d38f59f36"
            data-businessunit-id="604167dc856ba500017695d7"
            data-style-height="140px"
            data-style-width="100%"
            data-theme="light"
            data-stars="4,5"
            data-review-languages="en"
          >
            <a
              href="https://www.trustpilot.com/review/coachamerica.us"
              target="_blank"
              rel="noopener"
            ></a>
          </div>
        </div>
      )}
    </>
  );
}
